import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.66675 9.99999C1.66675 5.39762 5.39771 1.66666 10.0001 1.66666C14.6025 1.66666 18.3334 5.39762 18.3334 9.99999C18.3334 14.6024 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6024 1.66675 9.99999ZM13.3335 10.8332C13.7937 10.8332 14.1668 10.4601 14.1668 9.99988C14.1668 9.53964 13.7936 9.16656 13.3334 9.16657L10.8334 9.16664V6.66676C10.8334 6.20652 10.4603 5.83343 10.0001 5.83343C9.53984 5.83343 9.16675 6.20652 9.16675 6.66676V9.16669L6.66672 9.16676C6.20649 9.16677 5.8334 9.53988 5.83342 10.0001C5.83343 10.4604 6.20653 10.8334 6.66677 10.8334L9.16675 10.8334V13.3333C9.16675 13.7936 9.53984 14.1667 10.0001 14.1667C10.4603 14.1667 10.8334 13.7936 10.8334 13.3333V10.8333L13.3335 10.8332Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }